/* eslint-disable max-len */
import { AxiosError } from "axios";
import React, { Component } from "react";
import { ModalBody } from "reactstrap";
import { ModalHeader } from "reactstrap";
import { Modal } from "reactstrap";
import { saveOwnershipInformationdata } from "../OwnershipForm/Ownershipinfomationdata";
import OwnershipInformationUI from "./OwnershipInformationUI";
import { OptionsPayload, Question } from "../../../../models/ComplianeQuestionarie";
import Service from "../../../../services";
import { BankUserContext } from "../../../../bankUserContext";
import { ParseJson, catchError } from "../../../../utils/Utils";
import { QuestionTypes } from "../../../../utils/QuestionTypes";
import FinSpinner from "../../../../commonfields/FinSpinner";
import { connect } from "react-redux";
import { change } from "redux-form";


interface OwnershipInformationMainCCProps {
  OwnersInformation: any[];
  getAllOwnershipContacts: any;
  entityType: any;
  clientStockData: any;
  clientProductsId: any;
  disableFields: any;

}

interface OwnershipInformationMainCCState {
  individualsData: Question[];
  loader: boolean;
  showAImodal: boolean;
  questionObj: Question | null;
  fileHandlerClick: boolean;
}

class OwnershipInformationMainCC extends Component<
  any,
  OwnershipInformationMainCCState
> {
  service = new Service();
  static contextType = BankUserContext;
  context: React.ContextType<typeof BankUserContext> | undefined;
  constructor(props: any) {
    super(props);
    this.state = {
      individualsData: [],
      loader: false,
      showAImodal: false,
      questionObj: null,
      fileHandlerClick: false,
    };
  }

  getownersInformation = (ownerId: string, groupType: string) => {
    const entityType = this.props.entityType.text;
    //const groupType = '';
    this.setState({ loader: true });
    this.service
      .getAdditionalOwnerQuestions(ownerId, entityType, groupType)
      .then((response: any) => {
        response?.data?.forEach((m: any, index: number) => {
          m.clientQuestionId = index;
          m.serialNumber = 0;
        });
        this.setState({ individualsData: response.data, loader: false });
      })
      .catch((error: any) => {
        catchError(true, error);
        this.setState({ loader: false });
      });
  };
  deleteOwner = (ownerId: any) => {
    this.setState({ loader: true });
    !this.props.disableFields && this.service.deleteContact(ownerId, this.props.clientProductsId).then((res: any) => {
      this.props.getAllOwnershipContacts();
    })
    this.setState({ loader: false })

  }
  makeAuthSignerPrimary = (ownerId: any, isPrimary: boolean) => {
    this.setState({ loader: true });
    this.service.makeAuthSignerPrimary(ownerId, isPrimary).then((res: any) => {
      this.props.getAllOwnershipContacts();
    })
    this.setState({ loader: false })

  }

  markAsPrimary = (ownerInfo: any) => {
    const PrimaryUpdate = {
      groupId: ownerInfo.groupId,
      grouped: ownerInfo.grouped,
      individualId: ownerInfo.individualId,
      clientProductsId: this.props.clientProductsId,
      ownerId: ownerInfo.ownerId,
      primary: true,
    };
    this.service
      .updateIndividualOwner(PrimaryUpdate)
      .then((res: any) => {
        //  this.getownersInformation
        this.props.getAllOwnershipContacts();
      })
      .catch((Err: AxiosError) => {
        catchError(Err, true);
      });
  };

  onSaveQuestion = (question: Question, oldAnswer: any) => {
    this.setState({ questionObj: question });
    if (
      question.answers &&
      question.answers?.length > 0 &&
      question.answers[0].answer !== ""
    ) {
      if (
        question.questionType == QuestionTypes.FileUpload &&
        question.answers
      ) {
        this.setState({ loader: true });
        const fileObj = question.answers[0].answer;
        this.service.validationByAiForOwners(question.answers[0].answer, question.questionId)
          .then((response: any) => {

            if (response.data.status) {
              this.service
                .postOwnerFileUsingPOST(
                  fileObj,
                  question.ownerId,
                  question.questionId,
                  false
                )
                .then((res: any) => {
                  if (res.data.questionarieFilledStatus == "Complete" && question?.isRequired) {
                    const filteredOwner: any = this.props.OwnersInformation.filter((n: { ownerId: any; }) => n.ownerId == question.ownerId);
                    if (filteredOwner) {
                      const isCompleted = filteredOwner[0]?.completed ? "Complete" : "Incomplete";

                      if (res.data.questionarieFilledStatus !== isCompleted) {
                        this.props.getAllOwnershipContacts();
                      }
                    }
                  }

                  const allQuestions: Question[] = Object.assign(
                    [],
                    this.state.individualsData
                  );

                  const currentQuestion = allQuestions.find(
                    (m: any) => m.clientQuestionId == question.clientQuestionId
                  );
                  if (currentQuestion) {
                    currentQuestion.answers = [{ answer: res.data.postFileStatus, optionId: null }];
                    this.setState({ individualsData: allQuestions });
                  }
                })
                .finally(() => {
                  this.setState({ loader: false });
                });
            }
            else {
              this.modalViewHandler();
            }
          }).catch((error: any) => {
            catchError(error, true);
            this.setState({ loader: false })
          })

      } else {
        const PostQuestionData: any = {
          answer: "",
          options: [],
          ownerId: question.ownerId,
          ownerQuestionId: question.questionId,
        };
        PostQuestionData.answer = question.answers[0].answer;
        if (question.options.length > 0) {
          PostQuestionData.options = question.answers.map((item) => {
            const Data: OptionsPayload = {
              questionOptionId: item.optionId,
              answer: item.answer,
            };
            return Data;
          });
        }
        this.service
          .saveOwnerResponse(PostQuestionData).then((response: any) => {
            if (response.data == "Complete" && question?.isRequired) {
              const filteredOwner: any = this.props.OwnersInformation.filter((n: { ownerId: any; }) => n.ownerId == question.ownerId);
              if (filteredOwner) {
                const isCompleted = filteredOwner[0]?.completed ? "Complete" : "Incomplete";
                if (response.data !== isCompleted) {
                  this.props.getAllOwnershipContacts();
                }
              }
            }
          })
          .catch((error: AxiosError) => {
            catchError(error, true);
          });
      }
    } else {
      // remove the response
      if (question.questionType !== QuestionTypes.FileUpload) {
        this.service
          .removeOwnerResponse(question.ownerId, question.questionId, this.props.clientProductsId).then((response: any) => {
            if (response.data == "Incomplete" && question?.isRequired) {
              const filteredOwner: any = this.props.OwnersInformation.filter((n: { ownerId: any; }) => n.ownerId == question.ownerId);

              if (filteredOwner) {
                const isCompleted = filteredOwner[0]?.completed ? "Complete" : "Incomplete";
                if (response.data !== isCompleted) {
                  this.props.getAllOwnershipContacts();
                }
              }
            }
          })
          .catch((error: AxiosError) => {
            catchError(error, true);
          });
      } else {
        if (
          oldAnswer[question.clientQuestionId] &&
          oldAnswer[question.clientQuestionId].length > 0
        ) {
          // eslint-disable-next-line no-var
          var filePath = null;
          //for removing the dependent question answer
          if (
            oldAnswer[question.clientQuestionId][0].answer &&
            typeof oldAnswer[question.clientQuestionId][0].answer === "string"
          ) {
            const fileObj = ParseJson(
              oldAnswer[question.clientQuestionId][0].answer
            );
            if (fileObj && fileObj.filePath) {
              filePath = fileObj.filePath;
            }
          } else if (
            oldAnswer[question.clientQuestionId][0].answer &&
            typeof oldAnswer[question.clientQuestionId][0].answer === "object"
          ) {
            const fileObj = oldAnswer[question.clientQuestionId][0].answer;
            if (fileObj && fileObj.filePath) {
              filePath = fileObj.filePath;
            }
          } else if (
            typeof oldAnswer[question.clientQuestionId][0] === "object"
          ) {
            // for delete on click of delete button
            filePath = oldAnswer[question.clientQuestionId][0].filePath;
          }
          this.service
            .deleteFileForOwner(question.ownerId, question.questionId, filePath).then((response: any) => {
              if (response.data.questionarieFilledStatus == "Incomplete" && question?.isRequired) {
                const filteredOwner: any = this.props.OwnersInformation.filter((n: { ownerId: any; }) => n.ownerId == question.ownerId);

                if (filteredOwner) {
                  const isCompleted = filteredOwner[0]?.completed ? "Complete" : "Incomplete";

                  if (response.data.questionarieFilledStatus !== isCompleted) {
                    this.props.getAllOwnershipContacts();
                  }
                }
              }
            })
            .catch((error: AxiosError) => {
              catchError(error, true);
            });
        }
      }
    }
  };
  addPerson = (mode: string, groupType: string) => {
    this.setState({ loader: true });
    const data = {
      "addedPerson": true,
      "authSigner": mode === 'authorizedSigner' ? "yes" : 'no',
      "corporateOfficer": mode === 'managingMember' ? "yes" : 'no',
      "clientId": this.context?.bankuserDetails?.userId,
      "clientProductsId": this.props.clientProductsId,
      "ownership": 0,
      "type": "Individuals"
    };

    this.service
      .postOwnerInformation(data)
      .then((res: any) => {
        this.setState({ loader: false });
        this.getownersInformation(res.data, groupType)
        this.props.getAllOwnershipContacts();
      })
      .catch((Err: AxiosError) => {
        catchError(Err, true);
      });
  };

  modalViewHandler = () => {
    this.setState({ showAImodal: !this.state.showAImodal })
  };


  closeModalViewHandler = () => {
    this.setState({ showAImodal: false })
    setTimeout(() => {
      const allQuestions: Question[] = Object.assign(
        [],
        this.state.individualsData
      );
      const CurrentQuestion = allQuestions.find(
        (m) => m.clientQuestionId == this.state.questionObj?.clientQuestionId
      );
      if (CurrentQuestion) {
        CurrentQuestion.answers = null;
        this.props.dispatch(change(`QuestionnaireForm${CurrentQuestion.ownerId}`, `question_${CurrentQuestion.clientQuestionId}`, []))
        this.setState({ individualsData: allQuestions, loader: false });
      }
    }, 500);

  };

  uplaodFileHandler = () => {
    this.setState({ fileHandlerClick: true })
    const { questionObj } = this.state
    if (questionObj?.answers && questionObj.answers?.length > 0 && questionObj.answers[0].answer !== "") {
      const fileObj = questionObj?.answers[0].answer;
      this.setState({ loader: true })

      this.service
        .postOwnerFileUsingPOST(
          fileObj,
          questionObj.ownerId,
          questionObj.questionId,
          false
        ).then((response: any) => {
          if (response.status == 200) {
            this.setState({ showAImodal: false })
            this.setState({ fileHandlerClick: false })
          }
          if (response.data.questionarieFilledStatus == "Complete") {
            const filteredOwner: any = this.props.OwnersInformation.filter((n: { ownerId: any; }) => n.ownerId == questionObj.ownerId);
            if (filteredOwner) {
              const isCompleted = filteredOwner[0]?.completed ? "Complete" : "Incomplete";

              if (response.data.questionarieFilledStatus !== isCompleted) {
                this.props.getAllOwnershipContacts();
              }
            }
          }
          const allQuestions: Question[] = Object.assign(
            [],
            this.state.individualsData
          );

          const currentQuestion = allQuestions.find(
            (m: any) => m.clientQuestionId == questionObj.clientQuestionId
          );
          if (currentQuestion) {
            currentQuestion.answers = [
              { answer: response.data.postFileStatus, optionId: null },
            ];
            this.setState({ individualsData: allQuestions });
          }
        }).catch((error: AxiosError) => {
          catchError(error, true);
        }).finally(() => {
          this.setState({ loader: false })
        });
    }

  }

  render() {
    return (
      <>
        {this.state.loader ? (
          <div className="spinnerDiv">
            <FinSpinner />
          </div>
        ) : (
          ""
        )}

        {(this.props.OwnersInformation.length > 0 || this.props.clientStockData?.publicTradedCompany == "true") &&
          <OwnershipInformationUI
            OwnersInformation={this.props.OwnersInformation}
            getownersInformation={this.getownersInformation}
            individualsData={this.state.individualsData}
            onSaveQuestion={this.onSaveQuestion}
            markAsPrimary={this.markAsPrimary}
            addPerson={this.addPerson}
            entityType={this.props.entityType}
            clientStockData={this.props.clientStockData}
            deleteOwner={this.deleteOwner}
            makeAuthSignerPrimary={this.makeAuthSignerPrimary}
            disableFields={this.props.disableFields}

          />}

        <div className="AIModalPopUpContainer">
          <Modal
            className="popup-modal"
            size="md"
            isOpen={this.state.showAImodal}
            fade={false}

          >
            <ModalHeader toggle={this.closeModalViewHandler} >
              <span className="headerText">
                Is this the correct document?</span>
            </ModalHeader>
            <ModalBody>
              <div className="bodyText">
                <span className="ourSystemText">Our system isn’t sure this is correct. </span><br />
                <span className="areYouSureText">Are you sure this is the </span>
              </div>
              <div className="modalBtnsDiv">
                <button onClick={this.closeModalViewHandler} className="noUploadBtn">No, upload a different file</button>
                <button onClick={this.uplaodFileHandler} disabled={this.state.fileHandlerClick} className="yesUploadBtn">Yes, attach this document</button>
              </div>
            </ModalBody>
          </Modal>
        </div>
      </>
    );
  }
}

export default connect()(OwnershipInformationMainCC)
